import { Body2, Box, Color } from '@gousto-internal/citrus-react';

export const FoodBrandPillTestId = 'food-brand-pill';

type Props = {
  foodBrand: string;
};
export function FoodBrandPill({ foodBrand }: Props) {
  return (
    <Box
      color={Color.ColdGrey_800}
      bg={Color.NeutralGrey_50}
      borderRadius={1.5}
      paddingV={0.25}
      paddingH={2}
      data-testid={FoodBrandPillTestId}
    >
      <Body2>{foodBrand}</Body2>
    </Box>
  );
}
